module.exports = __webpack_public_path__ + "img/logo-ub.3c2322a5.png";